import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import DoctorNewAppointmentPage from './DoctorNewAppointmentPage.js';

export default WithGASetup(DoctorNewAppointmentPage, AuthContext);
